
				var addMethods = require("../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = []
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "b28467eb19fd61226c29.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			